$(window).on("load", function(){

    if (typeof initializeMap === "function"){

        $.post(site_url + "ajax/functions.php", {
            operation: '_loadMapPins',
            map_image_size: (typeof map__image_size === undefined ? map__image_size : "thumbnail"),
        }, function(data) {

            initializeMap(data.config.map_latitude, data.config.map_longitude, data.config.map_zoom);

            //LOAD PINS IN MAP

            //Set Hotel Pin
            const hotel_marker = {
                id: 0,
                // name: data.hotel.name,
                name: data.hotel.name,
                description: data.hotel.description,
                thumb: data.hotel.thumb,
                // lat: data.hotel.lat,
                // long: data.hotel.long,
                url: "",
                // icon: data.hotel.icon
            };


            loadMarker(hotel_marker);
        
            const pins = data.pins;
            const number_of_pins = Object.keys(pins);

            for (let index = 1; index <= number_of_pins.length; ++index) {
                let pin =  pins[index];
                console.log(pin)
                loadMarker(pin);
            }

            //LOAD PINS IN SLIDER
            let map_pins_markup = `
                    <!-- <div class="map-pin">
                        <div class="info-wrapper">
                            <div class="headline-box">
                                <div class="headline-box__title">
                                    <h2>${hotel_marker.name}</h2>
                                </div>
                                <p>${hotel_marker.description}</p>
                            </div>
                        </div>
                        ${ hotel_marker.thumb !== "" ? `<img src="${hotel_marker.thumb}" alt="${hotel_marker.name} Photo" class="img-responsive">` : ""}
                    </div> -->`;

            for (let index = 1; index <= number_of_pins.length; ++index) {
                let pin =  pins[index];
                map_pins_markup += `
                    <div class="map-pin">
                        <div class="info-wrapper">
                            <div class="headline-box">
                                <div class="headline-box__title">
                                    <h2>${pin.name}</h2>
                                </div>
                                <p>${pin.description}</p>
                            </div>
                        </div>
                        ${ pin.thumb !== "" ? `<img src="${pin.thumb}" alt="${pin.name} Photo" class="img-responsive">` : ""}
                    </div>`;
            }

            slick_pins.html(map_pins_markup);
            // console.log(map_pins_markup)
            setTimeout(() => slick_pins.slick(), 1000)


        }, "json");

    }

});